import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';

import { TTransportType } from '../../../../types/transportType';
import * as styles from './FromUndergroundTime.css';

interface IFromUndergroundProps {
  transportType: TTransportType;
  timeTo: string;
}

export const FromUndergroundTime: React.FC<IFromUndergroundProps> = ({ transportType, timeTo }) => {
  const Icon = transportType === 'walk' ? IconMapWalk16 : IconMapCar16;

  return (
    <div className={styles['distance']}>
      <div className={styles['icon']}>
        <Icon color={'icon-secondary-default'} />
      </div>
      <UIText2 color={'gray60_100'}>{timeTo}</UIText2>
    </div>
  );
};
